import { render, staticRenderFns } from "./lesDocUp.vue?vue&type=template&id=09796903&scoped=true"
import script from "./lesDocUp.vue?vue&type=script&lang=js"
export * from "./lesDocUp.vue?vue&type=script&lang=js"
import style0 from "./lesDocUp.vue?vue&type=style&index=0&id=09796903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09796903",
  null
  
)

export default component.exports